export const translations = {
  en: {
    // Header & Navigation
    companyName: "ISOFLAM SARL",
    nav: {
      home: "Home",
      services: "Services",
      about: "About",
      testimonials: "Testimonials",
      faq: "FAQ",
      contact: "Contact"
    },

    // Hero Section
    hero: {
      title: "Professionalism and Experience",
      subtitle: "At Your Disposal!",
      description: "Specialized in waterproofing, insulation, and roofing solutions for over",
      cta: "Get a Free Quote"
    },

    // Statistics
    statistics: {
      quality: { label: "Quality", subtitle: "Proven" },
      trust: { label: "Trust", subtitle: "Absolute" },
      security: { label: "Security", subtitle: "Assured" },
      clients: { label: "Clients", subtitle: "Satisfied" }
    },

    // Services Section
    services: {
      title: "Our Services",
      description: "Comprehensive solutions for all your waterproofing, insulation, and roofing needs",
      waterproofing: {
        title: "Waterproofing",
        description: "Execution of all types of work related to waterproofing. Waterproofing of flat terraces is important to preserve its quality.",
        features: [
          "Synthetic membranes",
          "Bituminous waterproofing",
          "Asphalt waterproofing"
        ]
      },
      insulation: {
        title: "Insulation",
        description: "All types of work related to insulation including polyurethane, extruded polystyrene, and expanded glass foam.",
        features: [
          "Polyurethane",
          "Extruded polystyrene",
          "Expanded glass (Foamglas)"
        ]
      },
      roofing: {
        title: "Roofing",
        description: "Roofing is essential for a warm and dry house. We protect, seal, and insulate roofing composed of several elements forming successive layers.",
        features: [
          "Aesthetic roofing",
          "Waterproof solutions",
          "Ecological and sustainable"
        ]
      }
    },

    // About Section
    about: {
      title: "About ISOFLAM SARL",
      description: "Isoflam is a specialized company in waterproofing of flat terraces. With over 20 years of experience in the field and certified as a waterproof installer, we have earned the trust of our clients to protect their property and provide them with a reliable market reference in Luxembourg.",
      values: "Our values are simple: quality and rigor at work!",
      highlights: [
        "Certified waterproofing specialists",
        "Over 20 years of experience",
        "Trusted by 1000+ clients",
        "100% satisfaction guarantee"
      ],
      experienceLabel: "Of Experience"
    },

    // Testimonials Section
    testimonials: {
      title: "What Our Clients Say",
      subtitle: "Trusted by over 1000 satisfied clients",
      items: [
        {
          name: "Marc Dubois",
          company: "Residential Client",
          content: "Excellent work on our flat roof waterproofing. The team was professional, punctual, and the quality is outstanding. Highly recommended!"
        },
        {
          name: "Sophie Laurent",
          company: "Commercial Property Owner",
          content: "ISOFLAM completed our commercial building insulation project ahead of schedule. Their attention to detail and expertise is remarkable."
        },
        {
          name: "Jean Weber",
          company: "Construction Manager",
          content: "We've worked with ISOFLAM on multiple projects. Their certified expertise and commitment to quality make them our go-to partner."
        }
      ]
    },

    // FAQ Section
    faq: {
      title: "Frequently Asked Questions",
      subtitle: "Find answers to common questions about our services",
      items: [
        {
          question: "What types of waterproofing do you specialize in?",
          answer: "We specialize in all types of waterproofing including synthetic membranes, bituminous waterproofing, and asphalt waterproofing. Our certified team has over 20 years of experience in flat roof waterproofing."
        },
        {
          question: "How long does a typical roofing project take?",
          answer: "Project duration varies based on size and complexity. A typical residential roofing project takes 3-7 days, while commercial projects may take 2-4 weeks. We provide detailed timelines during consultation."
        },
        {
          question: "Do you offer guarantees on your work?",
          answer: "Yes! We offer a 100% guarantee on all our services and products. Our work is backed by our commitment to quality and our certified expertise in waterproofing and insulation."
        },
        {
          question: "What insulation materials do you use?",
          answer: "We work with high-quality insulation materials including polyurethane, extruded polystyrene, and expanded glass foam (Foamglas). We recommend the best solution based on your specific needs."
        },
        {
          question: "Are you certified and insured?",
          answer: "Absolutely. We are a certified waterproofing company with all necessary licenses and comprehensive insurance. Our team follows strict safety protocols on every project."
        },
        {
          question: "Do you provide free estimates?",
          answer: "Yes, we provide free, no-obligation estimates for all projects. Contact us via phone or our contact form to schedule a consultation."
        }
      ]
    },

    // Contact Section
    contact: {
      title: "Get In Touch",
      description: "Ready to start your project? Contact us for a free consultation and estimate.",
      address: "Address",
      phone: "Phone",
      contactButton: "Contact Us",
      guarantee: {
        title: "100% Guarantee",
        subtitle: "On all our services and products!"
      }
    },

    // Footer
    footer: {
      description: "Certified specialists in waterproofing, insulation, and roofing solutions.",
      quickLinks: "Quick Links",
      contactInfo: "Contact Info",
      copyright: "All rights reserved."
    }
  },

  fr: {
    // Header & Navigation
    companyName: "ISOFLAM SARL",
    nav: {
      home: "Accueil",
      services: "Services",
      about: "À propos",
      testimonials: "Témoignages",
      faq: "FAQ",
      contact: "Contact"
    },

    // Hero Section
    hero: {
      title: "Professionnalisme et expérience",
      subtitle: "À votre disposition !",
      description: "Spécialisé dans l'étanchéité, l'isolation et les solutions de toiture depuis plus de",
      cta: "Obtenez un devis gratuit"
    },

    // Statistics
    statistics: {
      quality: { label: "Qualité", subtitle: "Éprouvée" },
      trust: { label: "Confiance", subtitle: "Absolue" },
      security: { label: "Sécurité", subtitle: "Assurée" },
      clients: { label: "Clients", subtitle: "Satisfait" }
    },

    // Services Section
    services: {
      title: "Nos Services",
      description: "Des solutions complètes pour tous vos besoins en étanchéité, isolation et toiture",
      waterproofing: {
        title: "Étanchéité",
        description: "Exécution de tous types de travaux liés à l'étanchéité. L'étanchéité des terrasses plates est importante pour préserver sa qualité.",
        features: [
          "Membranes synthétiques",
          "Étanchéité bitumineuse",
          "Étanchéité asphalte"
        ]
      },
      insulation: {
        title: "Isolation",
        description: "Tous types de travaux liés à l'isolation incluant le polyuréthane, le polystyrène extrudé et la mousse de verre expansé.",
        features: [
          "Polyuréthane",
          "Polystyrène extrudé",
          "Verre expansé (Foamglas)"
        ]
      },
      roofing: {
        title: "Toiture",
        description: "La toiture est indispensable pour être au chaud et au sec chez soi. Nous protégeons, étanchons et isolons la toiture composée de plusieurs éléments formant des couches successives.",
        features: [
          "Toiture esthétique",
          "Solutions d'étanchéité",
          "Écologique et durable"
        ]
      }
    },

    // About Section
    about: {
      title: "À propos d'ISOFLAM SARL",
      description: "Isoflam est une entreprise spécialisée dans l'étanchéité des toitures terrasses. Avec plus de 20 années d'expérience dans le domaine et certifiée en tant qu'étancheur, nous avons gagné la confiance de nos clients pour protéger leurs biens et leur fournir une référence fiable sur le marché luxembourgeois.",
      values: "Nos valeurs sont simples : qualité et rigueur de travail !",
      highlights: [
        "Spécialistes certifiés en étanchéité",
        "Plus de 20 ans d'expérience",
        "La confiance de plus de 1000 clients",
        "Garantie de satisfaction à 100%"
      ],
      experienceLabel: "D'expérience"
    },

    // Testimonials Section
    testimonials: {
      title: "Ce que disent nos clients",
      subtitle: "La confiance de plus de 1000 clients satisfaits",
      items: [
        {
          name: "Marc Dubois",
          company: "Client résidentiel",
          content: "Excellent travail sur l'étanchéité de notre toit plat. L'équipe était professionnelle, ponctuelle et la qualité est exceptionnelle. Hautement recommandé !"
        },
        {
          name: "Sophie Laurent",
          company: "Propriétaire immobilier commercial",
          content: "ISOFLAM a terminé notre projet d'isolation de bâtiment commercial avant la date prévue. Leur attention aux détails et leur expertise sont remarquables."
        },
        {
          name: "Jean Weber",
          company: "Chef de chantier",
          content: "Nous avons travaillé avec ISOFLAM sur plusieurs projets. Leur expertise certifiée et leur engagement envers la qualité en font notre partenaire de référence."
        }
      ]
    },

    // FAQ Section
    faq: {
      title: "Questions Fréquemment Posées",
      subtitle: "Trouvez des réponses aux questions courantes sur nos services",
      items: [
        {
          question: "Quels types d'étanchéité proposez-vous ?",
          answer: "Nous sommes spécialisés dans tous les types d'étanchéité, y compris les membranes synthétiques, l'étanchéité bitumineuse et l'étanchéité asphalte. Notre équipe certifiée possède plus de 20 ans d'expérience dans l'étanchéité des toits plats."
        },
        {
          question: "Combien de temps dure un projet de toiture typique ?",
          answer: "La durée du projet varie en fonction de la taille et de la complexité. Un projet de toiture résidentielle typique prend 3 à 7 jours, tandis que les projets commerciaux peuvent prendre 2 à 4 semaines. Nous fournissons des calendriers détaillés lors de la consultation."
        },
        {
          question: "Offrez-vous des garanties sur vos travaux ?",
          answer: "Oui ! Nous offrons une garantie à 100% sur tous nos services et produits. Notre travail est soutenu par notre engagement envers la qualité et notre expertise certifiée en étanchéité et isolation."
        },
        {
          question: "Quels matériaux d'isolation utilisez-vous ?",
          answer: "Nous travaillons avec des matériaux d'isolation de haute qualité, notamment le polyuréthane, le polystyrène extrudé et la mousse de verre expansé (Foamglas). Nous recommandons la meilleure solution en fonction de vos besoins spécifiques."
        },
        {
          question: "Êtes-vous certifiés et assurés ?",
          answer: "Absolument. Nous sommes une entreprise d'étanchéité certifiée avec toutes les licences nécessaires et une assurance complète. Notre équipe suit des protocoles de sécurité stricts sur chaque projet."
        },
        {
          question: "Fournissez-vous des devis gratuits ?",
          answer: "Oui, nous fournissons des devis gratuits et sans engagement pour tous les projets. Contactez-nous par téléphone ou via notre formulaire de contact pour planifier une consultation."
        }
      ]
    },

    // Contact Section
    contact: {
      title: "Contactez-nous",
      description: "Prêt à démarrer votre projet ? Contactez-nous pour une consultation et un devis gratuits.",
      address: "Adresse",
      phone: "Téléphone",
      contactButton: "Nous contacter",
      guarantee: {
        title: "Garantie 100%",
        subtitle: "Sur tous nos services et produits !"
      }
    },

    // Footer
    footer: {
      description: "Spécialistes certifiés en étanchéité, isolation et solutions de toiture.",
      quickLinks: "Liens rapides",
      contactInfo: "Informations de contact",
      copyright: "Tous droits réservés."
    }
  }
};

export const getTranslation = (language) => {
  return translations[language] || translations.en;
};